import React from 'react'
import { formatPrice } from 'shared-constants'
import { DATA_TEST_CLASS, DATA_TEST_ID } from 'shared-constants/build/testIds'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'

interface ProductPriceProps extends React.ComponentProps<typeof Flex> {
  price?: {
    total: number
    currencyIsoCode?: string
  }
  isDiscount?: boolean
  color?: string
}

export const ProductPrice: React.FC<ProductPriceProps> = ({
  price,
  isDiscount = false,
  ...props
}) => (
  <Flex flexShrink={0} {...props}>
    <Text
      data-test-class={DATA_TEST_CLASS.SHOWROOM_PRODUCT_PRICE}
      data-test-id={DATA_TEST_ID.SHOWROOM_PRODUCT_PRICE}
    >
      {isDiscount && price?.total > 0 && '-'}
      {formatPrice({
        price: price?.total,
        currency: price?.currencyIsoCode,
      })}
    </Text>
  </Flex>
)
